import { wealthProApi } from '../../redux/api';

const recentlyOpenedMasterAccountEndpoints = wealthProApi.enhanceEndpoints({
    addTagTypes: ["recentclients"]
})
.injectEndpoints({
    endpoints: (build) => ({
        fetchRecentClientsList: build.query({
            query: ({ page = 1, limit = 10 }) => `api/logs/users/master-accounts/recent?page=${page}&limit=${limit}`,
            serializeQueryArgs: ({ endpointName }) => {
                return endpointName
            },
            merge: (currentCache, newItems) => {
                const { pagination: currPage } = currentCache || {};
                const { pagination: nextPage } = newItems || {};

                if (!currPage || nextPage.page <= currPage.page) {
                    return newItems;
                }

                currentCache.pagination = newItems.pagination;
                currentCache.results.push(...newItems.results)
            },
            forceRefetch({ currentArg, previousArg }) {
                const { page: currPage } = currentArg || { page: 1 };
                const { page: prevPage } = previousArg || { page: 0 };
                return currPage !== prevPage;
            },
            //providesTags: ["recentclients"]
        })
    })
});

export const {
    useFetchRecentClientsListQuery,
} = recentlyOpenedMasterAccountEndpoints;